import { useState } from 'react';
import { ServiceBooking, Reservation } from '@turizi/shared';
import { Popover, PopoverProps } from '@mantine/core';
import { BookingGroupSize } from '../snippets';
import BookingPaxsAssociation from './booking-paxs-association';

interface BookingPaxsPopoverProps {
    booking: ServiceBooking;
    reservation?: Reservation;
    position?: PopoverProps['position'];
}

export default function BookingPaxsPopover({
    booking,
    reservation,
    position = 'right',
}: BookingPaxsPopoverProps) {
    const [opened, setOpened] = useState(false);

    return (
        <Popover
            opened={opened}
            onChange={setOpened}
            keepMounted={false}
            shadow="md"
            radius="lg"
            withArrow={true}
            closeOnClickOutside={true}
            closeOnEscape={true}
            clickOutsideEvents={['mousedown', 'touchstart']}
            position={position}
        >
            <Popover.Target>
                <div
                    className="cursor-pointer"
                    onClick={(e) => {
                        e.stopPropagation();
                        setOpened((o) => !o);
                    }}
                >
                    <BookingGroupSize
                        showPaxData={false}
                        booking={booking}
                        reservation={reservation}
                        active={opened}
                    />
                </div>
            </Popover.Target>
            <Popover.Dropdown
                onClick={(e) => e.stopPropagation()}
            >
                <BookingPaxsAssociation
                    booking={booking}
                    reservation={reservation}
                />
            </Popover.Dropdown>
        </Popover>
    );
}
